// extracted by mini-css-extract-plugin
export default {"info":"PurchasesInfo_info__JYxCI","description":"PurchasesInfo_description__hv1qD","links":"PurchasesInfo_links__Ozxen","link":"PurchasesInfo_link__a09Ba"};